import React, {useState} from 'react'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import Form from 'components/Form';
import * as Yup from 'yup';
import useId from 'hooks/useId';
import {connect} from 'react-redux'
import VS from "constants/ValidationShema";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import isResponseValid from "libs/isResponseValid";
import RfxOfferService from "services/RfxOfferService";
import Loading from "components/Loading";
import PropTypes from 'prop-types';
import moment from "libs/moment";
import DateBind from "./DateBind";
import getObjectValue from "libs/getObjectValue";
import periodValues from "./constants/period.values";
import {Alert} from "@material-ui/lab";
import UpdatedDateBind from "./UpdatedDateBind";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";

const useStyle = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(2),
    }
}))
function UpdateBindWithTheOfferDatePopup(
    {
        rfxRound,
        onClose,
        onUpdate,
        formSubmit,
    }) {

    const classes = useStyle();
    const [error, setError] = useState('');
    const [working, setWorking] = useState(false);
    const [loading, setLoading] = useState(false);
    const formId = useId();
    const handleSubmit = () => {
        setError('');
        formSubmit[formId]();
    }

    const getField = (id, defaultValue = '') => getObjectValue(id, rfxRound, defaultValue)

    const handleSaveResponse = (response) => {
        if (isResponseValid(response, setError)) {
            onUpdate();
            onClose();
        }
    }

    const onSubmit = (values) => {
        setWorking(true);
        setLoading(true);

        const req = {
            roundId: rfxRound.id,
            updatedBindWithOfferPeriodOrDate: {
                date: values.updatedBindWithOfferPeriodOrDate.date.format(),
                period: {
                    length: values.updatedBindWithOfferPeriodOrDate.period.length,
                    name: values.updatedBindWithOfferPeriodOrDate.period.name,
                },
                pickDateInsteadOfPeriod: getPickDateInsteadOfPeriod(),
            }
        }
        RfxOfferService.updateBindWithTheOfferDate(rfxRound.id, req)
            .then((resp) => handleSaveResponse(resp))
            .finally(() => {
                setWorking(false);
                setLoading(false);
            });
    }

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), () => onClose(true), 'outlined', working));
        buttons.push(createButton(Tr('save'), handleSubmit, undefined, working || loading));
        return buttons;
    }

    const getPickDateInsteadOfPeriod = () => {
        const date = getField('bindWithOfferPeriodOrDate.date', null);
        if (date === null) {
            const periodLen = getField('bindWithOfferPeriodOrDate.period.length', null);
            if (periodLen === null) return 'empty'
            return 'false'
        }
        return 'true'
    }

    const getUpdatedPickDateInsteadOfPeriod = () => {
        const date = getField('updatedBindWithOfferPeriodOrDate.date', null);
        if (date === null) {
            const periodLen = getField('updatedBindWithOfferPeriodOrDate.period.length', null);
            if (periodLen === null) return 'empty'
            return 'false'
        }
        return 'true'
    }

    const validationSchema = Yup.lazy((value) => {
        const schema = {}

        if (value.updatedBindWithOfferPeriodOrDate.pickDateInsteadOfPeriod === 'true') {
            schema['updatedBindWithOfferPeriodOrDate'] = Yup.object().shape({
                date: VS.dateMin(new Date(), Tr('v_data_can_not_be_past'))
            })

        }

        return Yup.object().shape(schema);
    })

    return (
        <Dialog
            title={Tr('update_bind_with_the_offer_date')}
            open={true}
            maxWidth='md'
            dialogActions={<MultiButton buttons={getButtons()}/>}
        >
            {loading ? <Loading/> :
                <Form
                    initialValues={{
                        bindWithOfferPeriodOrDate: {
                            date: moment(getField('bindWithOfferPeriodOrDate.date', new Date())),
                            period: {
                                length: getField('bindWithOfferPeriodOrDate.period.length', periodValues[0].value),
                                name: getField('bindWithOfferPeriodOrDate.period.name', 'day'),
                            },
                            pickDateInsteadOfPeriod: getPickDateInsteadOfPeriod(),
                        },
                        updatedBindWithOfferPeriodOrDate: {
                            date: moment(getField('updatedBindWithOfferPeriodOrDate.date', new Date())),
                            period: {
                                length: getField('updatedBindWithOfferPeriodOrDate.period.length', periodValues[0].value),
                                name: getField('updatedBindWithOfferPeriodOrDate.period.name', 'day'),
                            },
                            pickDateInsteadOfPeriod: getUpdatedPickDateInsteadOfPeriod(),
                        },
                    }}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                    id={formId}
                >
                    {(formikProps) => (
                        <>
                            <Alert severity="warning" classes={classes}>{Tr('update_bind_with_the_offer_date_warning')}</Alert>

                            {error && <Typography color='error'>{error}</Typography>}

                            <DateBind
                                title={Tr('date_binding_offer')}
                                formikProps={{ ...formikProps, values: { ...formikProps.values, _editable: false } }}
                                initialPickDateInsteadOfPeriod={getPickDateInsteadOfPeriod()}
                            />

                            <UpdatedDateBind
                                title={Tr('updated_binding_offer')}
                                formikProps={formikProps}
                                initialPickDateInsteadOfPeriod={getUpdatedPickDateInsteadOfPeriod()}
                            />
                        </>
                    )}
                </Form>
            }
        </Dialog>
    )
}


UpdateBindWithTheOfferDatePopup.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    rfxRound: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(UpdateBindWithTheOfferDatePopup);